
import { toast } from "react-toastify";
const url = `${process.env.REACT_APP_BASEURL}/api/decisionTree`;
const url_questionnaire = `${process.env.REACT_APP_BASEURL}/api/questionnaire`;


const getFun = (child) => {
    const convertToArrayOfObjects = (child) => {
        return Object.entries(child).map(([key, value]) => {
            return { key, value: value.toString() };
        });
    };

    const result = convertToArrayOfObjects(child);
    return result;
};

////////////////////DecisionTree-Get//////////////////////
export const getDecisionTreeListApi = async () => {

    try {
        const response = await fetch(url, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error("Failed to fetch product data. Please try again.");
        }

        const data = await response.json();

        const getQueData = data?.data[0]?.numberOfYears?.map((item) => {
            return {
                id: item?._id,
                min: item?.min,
                max: item?.max,
                label: item?.label,
                children: item.totalScore?.map((subItem) => {
                    return {
                        id: subItem?._id,
                        min: subItem?.min,
                        max: subItem?.max,
                        label: subItem?.label,
                        riskLabel: subItem?.riskCategory,
                        topComment: subItem?.topComment,
                        middleComment: subItem?.middleComment,
                        bottomComment: subItem?.bottomComment,
                        stockDistribution: getFun(subItem?.investmentRecommendation),
                    };
                }),
            };
        });

        return { getQueData: getQueData, data: data }

    } catch (error) {
        console.error("Error fetching product data:", error);
    }
};

////////////////////ExtraField//////////////////////
export const getExtraFieldApi = async () => {
    try {
        const response = await fetch(url_questionnaire, {
            method: "GET",
        });

        if (!response.ok) {
            throw new Error("Failed to fetch product data. Please try again.");
        }

        return await response.json();
    } catch (error) {
        console.error("Error fetching product data:", error);
    }
};

////////////////////DecisionTree-PostUpdate//////////////////////
const updateArryApi = async (data, isPost) => {
    try {
        const response = await fetch(
            url,
            {
                method: "PATCH",
                body: JSON.stringify({
                    decisionTreeId: isPost?.id,
                    numberOfYears: data,
                }),
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                    "Content-Type": "application/json",
                },
            }
        );

        let responseData = await response.json();
        if (response.status === 201) {
            toast.success("Form created successfully");
        }
        if (response.status === 200) {
            toast.success("Form updated successfully");
        }
        if (!response?.ok) {
            toast.error(responseData?.message);
        }

        if (!response.status) {
            toast.success(responseData?.message);
        }
    } catch (error) {
        const errorMessage = await error?.message;
        toast.error(errorMessage);
        console.error(error);
    }
};

const postArryApi = async (data, extraFieldId) => {
    const postData = data;
    try {
        const response = await fetch(
            url,
            {
                method: "POST",
                body: JSON.stringify({
                    numberOfYears: postData,
                    questionId: extraFieldId,
                }),
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                    "Content-Type": "application/json",
                },
            }
        );
        let responseData = await response.json();
        if (!response?.ok) {
            toast.error(responseData?.message);
        }
    } catch (error) {
        console.error(error);
    }
};
const fun = (data) => {
    const d = {};
    data?.forEach((item) => {
        for (const key in item) {
            d[item.key] = +item.value;
        }
    });
    return d;
};

export const DecisionTreePostUpdateApi = async (noOfYears, extraFieldId, isPost) => {
    try {
        const form_field_value = noOfYears?.map((fv) => {
            if (fv?.id?.length) {
                return {
                    _id: fv?.id ? `${fv?.id}`.replaceAll("-", "") : "",
                    label: fv.label,
                    min: +fv.min,
                    max: +fv.max,
                    totalScore: fv.children?.map((c1) => {
                        if (c1?.id?.length) {
                            return {
                                _id: c1?.id ? `${c1?.id}`.replaceAll("-", "") : "",
                                label: c1?.label,
                                min: +c1?.min,
                                max: +c1?.max,
                                riskCategory: c1?.riskLabel,
                                topComment: c1?.topComment,
                                middleComment: c1?.middleComment,
                                bottomComment: c1?.bottomComment,
                                investmentRecommendation: fun(c1?.stockDistribution),
                            };
                        } else {
                            return {
                                label: c1?.label,
                                min: +c1?.min,
                                max: +c1?.max,
                                riskCategory: c1?.riskLabel,
                                topComment: c1?.topComment,
                                middleComment: c1?.middleComment,
                                bottomComment: c1?.bottomComment,
                                investmentRecommendation: fun(c1?.stockDistribution),
                            };
                        }
                    }),
                };
            } else {
                return {
                    label: fv.label,
                    min: +fv.min,
                    max: +fv.max,
                    totalScore: fv.children?.map((c1) => {
                        return {
                            label: c1?.label,
                            min: +c1?.min,
                            max: +c1?.max,
                            riskCategory: c1?.riskLabel,
                            topComment: c1?.topComment,
                            middleComment: c1?.middleComment,
                            bottomComment: c1?.bottomComment,
                            investmentRecommendation: fun(c1?.stockDistribution),
                        };
                    }),
                };
            }
        });

        if (isPost.flag) {
            updateArryApi(form_field_value, isPost);
        } else {
            postArryApi(form_field_value, extraFieldId);
        }
    } catch (error) {
        console.error(error);
    }
};

////////////////////DecisionTree-Delete//////////////////////
export const deleteDecisionTreeApi = async (queId, isPost) => {
    try {
        const bodyId = { decisionTreeId: isPost?.id, _id: queId };
        const response = await fetch(
            url,
            {
                method: "DELETE",
                "Content-Type": "application/json",
                body: JSON.stringify(bodyId),
            }
        );
        
        if (response.ok) {
            const responseData = await response.json();
            toast.success(
                responseData?.message || "Question is deleted successfully!"
            );
        } else {
            const data = await response.json();
            toast.error(Object.values(data).join(", ") || "Something went wrong");
            console.error("Failed to submit form");
        }
    } catch (error) {
        toast.error("Something went wrong");
        console.error(error, "Error submitting form:");
    }
};
